import React, { useState } from 'react';
import '../assets/AllTabsCommon.css';
import '../assets/FleetAnalytics.css';
import OnboardDeviceFleet from './OnboardDeviceFleet';
import OnboardLogMask from './OnboardLogMask';
import ContextCollectionRules from './ContextCollectionRules';
import ADLogCodeListManagement from './ADLogCodeListManagement';
import ADConfigManagement from './ADConfigManagement';

const TOP_TABS = [
    { key: 'onboard', label: 'Onboard Device' },
    { key: 'config',  label: 'Config Management' },
];

const CONFIG_TABS = [
    { key: 'logmasks',  label: 'Log Masks' },
    { key: 'context',   label: 'Context Rules' },
    { key: 'logcodes',  label: 'Log Codes' },
    { key: 'adconfig',  label: 'AD Configurations' },
];

function ConfigManagementPanel({ userInfo, role, preselectedAdId }) {
    const [activeTab, setActiveTab] = useState(preselectedAdId != null ? 'adconfig' : 'logmasks');

    React.useEffect(() => {
        if (preselectedAdId != null) setActiveTab('adconfig');
    }, [preselectedAdId]);

    return (
        <div>
            <div className="analytics-rt-sub-tabs" style={{ marginBottom: '24px' }}>
                {CONFIG_TABS.map((t) => (
                    <button
                        key={t.key}
                        className={`analytics-rt-sub-tab${activeTab === t.key ? ' active' : ''}`}
                        onClick={() => setActiveTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {activeTab === 'logmasks'  && <OnboardLogMask userInfo={userInfo} />}
            {activeTab === 'context'   && <ContextCollectionRules userInfo={userInfo} role={role} mode="both" />}
            {activeTab === 'logcodes'  && <ADLogCodeListManagement userInfo={userInfo} role={role} />}
            {activeTab === 'adconfig'  && <ADConfigManagement userInfo={userInfo} role={role} preselectedAdId={preselectedAdId} />}
        </div>
    );
}

function UtilitiesTab({ userInfo, role, preselectedAdId }) {
    const [activeTab, setActiveTab] = useState(preselectedAdId != null ? 'config' : 'onboard');

    React.useEffect(() => {
        if (preselectedAdId != null) setActiveTab('config');
    }, [preselectedAdId]);

    return (
        <div className="analytics-shell">
            <div className="analytics-tabs">
                {TOP_TABS.map((t) => (
                    <div
                        key={t.key}
                        className={`analytics-tab${activeTab === t.key ? ' active' : ''}`}
                        onClick={() => setActiveTab(t.key)}
                    >
                        {t.label}
                    </div>
                ))}
            </div>

            {activeTab === 'onboard' && <OnboardDeviceFleet userInfo={userInfo} />}
            {activeTab === 'config'  && <ConfigManagementPanel userInfo={userInfo} role={role} preselectedAdId={preselectedAdId} />}
        </div>
    );
}

export default UtilitiesTab;
